// extracted by mini-css-extract-plugin
export default {"formBuilderDiv":"ForcedRedirections_formBuilderDiv__kZFGp"};